import styled from "styled-components";



import { getRandomColor } from "../utils/getRandomColor";
import { BaseScrollButton, Container } from "./common";


let dailyTimeSheetColor = [
  {
    main: "#EAF9F7",
    border: "#82C4BB",
  },
  {
    main: "#FBF3DA",
    border: "#FECF34",
  },
  {
    main: "#ECF0FC",
    border: "#9A96F9",
  },
];

//Timesheet Filter
export const FilterContainer = styled.div`
  display: flex;
  column-gap: 35px;
  justify-content: flex-start;
  align-items: center;
  margin-top: ${({ marginTop }) => marginTop || "30px"};
  margin-bottom: ${({ showShadow }) => (showShadow ? "20px" : "0")};
  flex-wrap: wrap;
  margin-top: ${({ isStuck }) => (isStuck ? "0px" : "30px")};
  /* Small screens: mobile */
  @media screen and (max-width: 412px) {
    & > :first-child {
      flex: 1 1 100%; /* takes full width */
    }

    & > :not(:first-child) {
      flex: 0 1 auto; /* takes natural width and wraps if needed */
    }

    justify-content: space-between;
    column-gap: 10px;
    row-gap: 10px; /* optional: smaller gap on mobile */
  }
`;

// Sticky Filter Container for Daily Timesheet
export const StickyFilterContainer = styled.div`
  position: sticky;
  top: 0;
  z-index: 2;
  background: ${({ bgColor, showShadow, theme }) =>
    bgColor || (showShadow ? theme?.colors?.main?.white || "#fff" : "none")};
  margin: ${({ margin }) => margin || "0 -30px 20px -30px"};
  padding-left: ${({ paddingLeft }) => paddingLeft || "30px"};
  padding-right: ${({ paddingRight }) => paddingRight || "30px"};
  box-shadow: ${({ showShadow }) =>
    showShadow ? "0 2px 8px rgba(0, 0, 0, 0.1)" : "none"};
  border-bottom: ${({ showShadow }) =>
    showShadow ? "1px solid #f0f0f0" : "none"};
  transition: all 0.3s ease;

  &:hover {
    box-shadow: ${({ showShadow }) =>
      showShadow ? "0 4px 12px rgba(0, 0, 0, 0.15)" : "none"};
  }

  @media screen and (max-width: 768px) {
    position: relative;
    margin: 0 -15px 15px -15px;
    padding-left: 15px;
    padding-right: 15px;
    padding: 10px 15px;
    box-shadow: none;
    border-bottom: none;
  }
`;

export const FilterSubContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr auto;
  grid-column-gap: 20px;
  justify-content: space-between;
  /* max-width: 600px; */
`;
export const TimesheetContainer = styled(Container)`
  padding: 25px 25px 25px;
`;

export const ScheduleContainer = styled(Container)`
  padding: ${({ padding }) => padding || "25px 25px 25px"};
  margin-top: ${({ marginTop }) => marginTop || "0"};
  @media (max-width: 1340px) {
    max-width: 100vw;
    overflow: auto;
  }
`;

export const ScheduleRightContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  border: 1px solid #e1e5e8;
  border-radius: 6px;
  margin-top: ${({ marginTop }) => marginTop || "70px"};
  height: 630px;
`;

export const ScheduleRightContainerHeader = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  padding: 6px;
  border-bottom: 1px solid #e1e5e8;
  background: ${({ bgColor, theme }) =>
    bgColor || theme.colors.main.tableHeaderBackground};
  color: ${({ theme }) => theme.font.pageText.colorLabel};
  // font-size: ${({ theme }) => theme.font.pageText.size};
  // font-weight: ${({ theme }) => theme.fontWeights.semibold};
`;

export const JobItemContainer = styled.div`
  display: flex;
  flex-direction: ${({ compact }) => (compact ? "row" : "column")};
  align-items: ${({ compact }) => (compact ? "center" : "stretch")};
  justify-content: flex-start;
  gap: ${({ compact }) => (compact ? "6px" : "2px")};
  background: ${({ theme }) => theme.colors.main.white || "#FFFFFF"};
  border: 1px solid #efefef;
  border-radius: ${({ compact }) => (compact ? "4px" : "8px")};
  padding: ${({ compact }) => (compact ? "4px 6px" : "10px")};
  opacity: ${({ isDragging }) => (isDragging ? 0.5 : 1)};
  cursor: ${({ isDragging }) => (isDragging ? "grabbing" : "grab")};
  transition: opacity 0.2s ease, background-color 0.2s ease;

  &:hover {
    background: #fafafa;
  }
`;

export const JobItemDot = styled.span`
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: #a3a3a3;
  flex-shrink: 0;
`;

export const JobItemTitle = styled.div`
  font-size: 12px;
  font-weight: 700;
  color: #102437;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const JobItemMeta = styled.div`
  font-size: 11px;
  font-weight: 500;
  color: #a3a3a3;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const ScheduleRightContainerBody = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  background: ${({ bgColor, theme, isOver }) =>
    isOver
      ? theme.colors.main.secondary || "#f0f0f0"
      : bgColor || theme.colors.main.white};
  padding: 2px;
  border-radius: ${({ isOver }) => (isOver ? "6px" : "0")};
  border: ${({ isOver, theme }) =>
    isOver ? `2px dashed ${theme.colors.main.primary || "#2268EF"}` : "none"};
  transition: all 0.2s ease;
  height: ${({ view }) => (view === "month" ? "740px" : "555px")};
  overflow-y: auto;
`;

export const TotalTimeContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const TimeRangeText = styled.p`
  margin: 0;
  font-size: ${({ theme }) => theme.font.pageText.size};
  font-weight: ${({ theme }) => theme.fontWeights.semibold};
  color: ${({ theme }) => theme.font.pageText.colorSecondary};
`;
export const TotalTimeDiv = styled.div`
  height: 40px;
  padding: 10px 20px;
  display: flex;
  justify-content: center;
  align-items: center;
  background: #ecf0fc;
  border-radius: 6px;
  margin-left: ${props => (props.monthly ? "0" : "40px")};
`;

export const TotalTimeLabel = styled.span`
  font-size: ${({ theme }) => theme.font.otherLabel.size};
  font-weight: ${({ theme }) => theme.fontWeights.semibold};
  color: ${({ theme }) => theme.font.pageText.colorLabel};
`;
export const TotalTimeText = styled(TotalTimeLabel)`
  font-size: ${({ theme }) => theme.font.pageText.size};
  color: ${({ theme }) => theme.font.pageText.colorSecondary};
  margin-left: ${({ marginLeft }) => marginLeft || "15px"};
`;

export const SecondsSpan = styled.span`
  font-size: 10px;
  font-weight: 500;
  margin-left: 4px;
`;

export const TableContainer = styled.div`
  margin-top: 25px;
  min-height: 250px;
  width: 100%;
  overflow-x: auto;
  overflow-y: hidden;
`;
export const TableHeadContainer = styled.div`
  display: grid;
  height: 45px;
  background: ${({ bgColor, theme }) =>
    bgColor || theme.colors.main.tableHeaderBackground};
  border-radius: ${({ borderRadius, theme }) =>
    borderRadius || theme.borderRadii.button};
  grid-template-columns: ${props =>
    props.custom
      ? `minmax(115px, 14.285%) minmax(115px, 14.285%) minmax(115px, 14.285%)
    minmax(115px, 14.285%) minmax(115px, 14.285%) minmax(115px, 14.285%) minmax(
      115px,
      14.285%
    )`
      : `minmax(115px, 12.5%) minmax(115px, 12.5%) minmax(115px, 12.5%)
    minmax(115px, 12.5%) minmax(115px, 12.5%) minmax(115px, 12.5%) minmax(
      115px,
      12.5%
    )
    minmax(115px, 12.5%)`};
`;
export const TableBodyContainer = styled.div`
  display: grid;
  grid-template-columns: ${props =>
    props.custom
      ? `minmax(115px, 14.285%) minmax(115px, 14.285%) minmax(115px, 14.285%)
    minmax(115px, 14.285%) minmax(115px, 14.285%) minmax(115px, 14.285%) minmax(
      115px,
      14.285%
    )`
      : `minmax(115px, 12.5%) minmax(115px, 12.5%) minmax(115px, 12.5%)
    minmax(115px, 12.5%) minmax(115px, 12.5%) minmax(115px, 12.5%) minmax(
      115px,
      12.5%
    )
    minmax(115px, 12.5%)`};
  height: 125px;
`;
export const TableHeadItem = styled.div`
  font-size: ${({ theme }) => theme.font.otherLabel.size};
  color: ${({ theme }) => theme.font.otherLabel.color};
  font-weight: ${({ theme }) => theme.font.otherLabel.weight};
  display: flex;
  justify-content: center;
  align-items: center;
  background: #f6f8f9;
  border: 1px solid #f6f8f9;
  text-transform: ${props => (props.total ? "none" : "capitalize")};
`;
export const TableBodyItem = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  border-bottom: 1px solid #f6f8f9;
  &:first-child {
    border-left: 1px solid #f6f8f9;
  }
  &:last-child {
    border-right: 1px solid #f6f8f9;
  }
`;
export const DailyTime = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 36px;
  width: 90px;
  border-radius: 6px;
  background: ${({ backgroundColor }) => backgroundColor || "#EAF9F7"};
  font-size: ${({ theme }) => theme.font.pageText.size};
  color: ${({ theme }) => theme.font.pageText.colorSecondary};
  font-weight: ${({ theme }) => theme.fontWeights.semibold};
  border: ${({ isActive, theme }) =>
    isActive ? `2px solid ${theme.colors.main.primary}` : "none"};
  z-index: ${({ largerZ }) => (largerZ ? 2001 : "auto")};
`;
export const TimesheetDate = styled.div`
  font-size: ${({ theme }) => theme.font.otherLabel.size};
  color: ${({ theme }) => theme.font.otherLabel.color};
  margin-top: 10px;
  background: ${({ today }) => (today ? "rgba(34, 102, 239,0.15)" : "auto")};
  padding: 4px;
  border-radius: 4px;
`;
export const WeeklyTotal = styled.div`
  width: 90px;
  height: 36px;
  display: flex;
  color: ${({ theme }) => theme.font.pageText.colorLabel};
  justify-content: center;
  align-items: center;
  font-size: ${({ theme }) => theme.font.pageText.size};
  font-weight: ${({ theme }) => theme.fontWeights.semibold};
  background: #ecf0fc;
  border-radius: ${({ theme }) => theme.borderRadii.button};
  margin-bottom: 30px;
`;

//Weekly details
export const WeeklyDetailsTableContainer = styled.div`
  padding-bottom: 25px;
  width: 100%;
  max-height: 70vh;
  overflow-x: auto;
  overflow-y: auto;
  @media screen and (max-width: 1400px) {
    max-height: 60vh;
  }
`;
export const WeeklyDetailsTableHeadContainer = styled.div`
  display: grid;
  grid-template-columns:
    minmax(150px, 21%) minmax(70px, 9%) minmax(70px, 9%)
    minmax(70px, 9%) minmax(70px, 9%) minmax(70px, 9%) minmax(70px, 9%)
    minmax(70px, 9%) minmax(80px, 15%);
  align-items: ${({ alignItems }) => alignItems || "center"};
`;

export const TableHeadText = styled.div`
  display: flex;
  height: ${({ height }) => height || "auto"};
  justify-content: center;
  align-items: center;
  background: ${({ bg }) => bg || "auto"};
  color: ${({ color, theme }) => color || theme.font.otherLabel.color};
  font-size: ${({ fontSize, theme }) => fontSize || theme.font.otherLabel.size};
  font-weight: ${({ fontWeight, theme }) =>
    fontWeight || theme.font.pageText.weight};
  margin: ${({ margin }) => margin || "15px 0 0 0"};
`;
export const TableHeadDateContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  align-items: ${({ alignItems }) => alignItems || "center"};
`;
export const TableHeadDayText = styled.div`
  color: ${({ color, theme }) => color || theme.font.otherLabel.color};
  font-size: ${({ fontSize, theme }) => fontSize || theme.font.otherLabel.size};
  font-weight: ${({ fontWeight, theme }) =>
    fontWeight || theme.font.pageText.weight};
`;
export const TableHeadDate = styled.div`
  height: 40px;
  width: 40px;
  border: 1px solid ${({ theme }) => theme.colors.border.secondaryLight};
  border-radius: ${({ theme }) => theme.borderRadii.input};
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: ${({ theme }) => theme.font.pageText.size};
  color: ${({ theme }) => theme.font.pageText.colorSecondary};
  background: ${({ today }) => (today ? "rgba(34, 102, 239,0.15)" : "#fcfdfe")};
  margin-top: 5px;
`;

export const TableHeadMonthText = styled.div`
  color: ${({ color, theme }) => color || theme.font.otherLabel.color};
  font-size: ${({ fontSize }) => fontSize || "10px"};
  text-align: center;
  margin-top: 4px;
`;

export const WeeklyDetailsTableBodyContainer = styled.div`
  margin-top: 10px;
`;

export const TableBodySingleItemContainer = styled.div`
  display: grid;
  grid-template-columns:
    minmax(150px, 21%) minmax(70px, 9%) minmax(70px, 9%)
    minmax(70px, 9%) minmax(70px, 9%) minmax(70px, 9%) minmax(70px, 9%)
    minmax(70px, 9%) minmax(80px, 15%);
  align-items: center;
  min-height: 60px;
`;
export const SingleItemUserDiv = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  height: 60px;
  padding-left: 10px;
  border: 1px solid #f0f3f7;
`;
export const SingleItemUserAvatar = styled.img`
  height: ${({ size }) => size || "36px"};
  width: ${({ size }) => size || "36px"};
  border-radius: ${({ theme }) => theme.borderRadii.circle};
  border: 1px solid ${({ theme }) => theme.colors.border.secondary};
`;
export const SingleItemUserName = styled.div`
  font-size: ${({ theme }) => theme.font.pageText.size};
  font-weight: ${({ theme }) => theme.font.pageText.weight};
  color: ${({ theme }) => theme.font.pageText.colorSecondary};
  margin-left: 10px;
`;
export const SingleItemTime = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: ${({ fontSize, theme }) => fontSize || theme.font.pageText.size};
  border: 1px solid #f0f3f7;
  color: ${({ theme }) => theme.font.pageText.colorSecondary};
  height: 60px;
  cursor: ${({ hasTime }) => hasTime && "pointer"};
  z-index: ${({ largerZ, hasTime }) => (largerZ && hasTime ? 2001 : "auto")};
  &:hover {
    text-decoration: ${({ hasTime }) => hasTime && "underline"};
  }
`;
export const SingleItemTimeText = styled.p`
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  height: 35px;
  min-width: 72px;
  margin: 0;
  padding: 6px;
  border: ${({ isActive, theme }) =>
    isActive ? `2px solid ${theme.colors.main.primary}` : "none"};
  border-radius: 6px;
`;

export const SingleItemTotal = styled.div`
  width: 78px;
  height: ${({ height }) => height || "36px"};
  background: ${({ background, blank, theme }) =>
    background
      ? background
      : !blank
      ? "white"
      : theme.colors.main.grayTimeSheet};
  border-radius: 6px;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 5px;
  font-size: ${({ fontSize, theme }) => fontSize || theme.font.pageText.size};
  font-weight: ${({ theme }) => theme.fontWeights.semibold};
  color: ${({ theme }) => theme.font.pageText.colorSecondary};
`;

export const SingleItemTotalAuto = styled(SingleItemTotal)`
  width: auto;
  overflow-x: visible;
`;

export const TimeWrapper = styled.span`
  display: flex;
  align-items: center;
  font-size: 14px;
`;

export const TimePart = styled.span`
  font-weight: ${props => (props.active ? "bold" : "normal")};
  color: ${props => (props.active ? "black" : "black")};
  margin: 0;
`;

export const Colon = styled.span`
  color: #999; /* gray for separator */
  margin: 0;
`;

//TIMESHEET DAILY
export const CalendarContainer = styled.div`
  display: grid;
  grid-template-columns: 80px 1fr;
  grid-column-gap: 20px;
  position: relative;
`;
export const UpperTotalHour = styled.div`
  display: grid;
  grid-template-columns: ${({ columns }) => columns || "auto auto"};
  grid-column-gap: 15px;
  border-radius: ${({ theme }) => theme.borderRadii.button};
  padding: 10px 15px;
  background-color: ${({ bgColor }) => bgColor || "#ecf0fc"};
  margin-top: auto;
  position: relative;
`;
export const TimeText = styled.div`
  font-size: 16px;
  color: #2f394e;
`;
export const TimeSlot = styled.div`
  border-top: ${({ index, startPosition }) =>
    index === startPosition && `1px solid #f0f3f7`};
  border-bottom: 1px solid #f0f3f7;
  height: 75px;
`;
export const TimeSlotCard = styled.div`
  position: absolute;
  top: ${({ top, startPosition }) => `${top - startPosition * 75}px`};
  left: ${({ left }) => `${left ?? 120}px`};
  height: ${({ height }) => `${height}px`};
  width: 670px;
  background-color: ${({ small, index, bgColor }) =>
    bgColor
      ? bgColor
      : small
      ? dailyTimeSheetColor[index % 3].border
      : dailyTimeSheetColor[index % 3].main};
  padding: ${({ padding }) => padding ?? "0 40px"};
  border-radius: ${({ theme }) => theme.borderRadii.button};
  border-left: ${({ index, borderColor }) =>
    `7px solid ${
      borderColor ? borderColor : dailyTimeSheetColor[index % 3].border
    }`};
  cursor: ${({ clickable }) => (clickable ? "pointer" : "default")};
`;
export const TimeSlotSmallInfo = styled.div`
  position: absolute;
  left: 660px;
  top: ${({ top }) => `${top - 14}px`};
  height: 28px;
  width: 28px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: ${({ theme }) => theme.borderRadii.circle};
  cursor: pointer;
  background: ${({ index }) => dailyTimeSheetColor[index % 3].border};
`;

export const TimeSlotInnerCard = styled.div`
  position: relative;
  z-index: 1;
  display: grid;
  grid-template-columns: 1fr 100px 100px 100px;
  grid-column-gap: 15px;
  justify-content: space-around;
  align-content: center;
  text-align: center;
  height: 100%;
`;
export const IdleTimePopupHeader = styled.div`
  display: flex;
  width: 100%;
  height: 50px;
  justify-content: center;
  align-items: center;
  border-bottom: 1px solid #e4e7eb;
`;
export const IdleTimePopupTotalSection = styled.div`
  display: flex;
  align-items: center;
`;
export const IdleTimeDetailsDiv = styled.div`
  display: grid;
  grid-row-gap: 25px;
  padding: 25px 0px;
`;
export const IdleTimeDetailsRow = styled.div`
  display: grid;
  grid-template-columns: auto auto auto auto auto;
  grid-column-gap: 15px;
  justify-content: space-around;
  align-items: center;
  text-align: center;
  height: 46px;
`;

export const TimesheetTooltipContainer = styled.div`
  position: relative;
  display: none;
`;

export const IdleDeleteButton = styled.div`
  height: 28px;
  width: 28px;
  background-color: #fe5969;
  border-radius: 50%;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;

  &:hover {
    ${TimesheetTooltipContainer} {
      display: flex;
    }
  }
`;

export const DeleteButton = styled.div`
  position: absolute;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 28px;
  width: 28px;
  top: -17px;
  right: 0px;
  // background-color: ${({ theme }) => theme.colors.main.error};
  background-color: transparent;
  border-radius: ${({ theme }) => theme.borderRadii.circle};
  cursor: pointer;

  &:hover {
    ${TimesheetTooltipContainer} {
      display: flex;
    }
  }
`;
export const InfoButton = styled(DeleteButton)`
  background-color: ${({ index, bgColor }) =>
    bgColor ? bgColor : dailyTimeSheetColor[index % 3].border};
  right: ${({ right }) => right || "35px"};

  &:hover {
    filter: brightness(0.98);
  }
`;

export const ScrollToBottomButton = styled(BaseScrollButton)``;
export const ScrollToMoreButton = styled(BaseScrollButton)``;
export const ScrollToTopButton = styled(BaseScrollButton)`
  border: 2px dotted rgb(44, 44, 44);
`;